import type { FC } from 'react'

import type { HeroDto } from '@hcr/api/optimizely'
import { unit } from '@hcr/ui'
import { isNotNull } from '@hcr/utils'

import { useHoliday } from '../../contexts'
import { useDestinationDetailsQuery } from '../../hooks'
import { createDestinationDetailsContent } from '../../utils'

import { HeaderHome, LayoutHome } from './common'
import { HomeDestinationLoading } from './HomeDestinationLoading'
import { HomeEmpty } from './HomeEmpty'

const destinationDetailsContent = createDestinationDetailsContent({ slidesMargin: unit(3) })

interface HomeDestinationProps {
  hero: HeroDto
}

export const HomeDestination: FC<HomeDestinationProps> = ({ hero }) => {
  const holiday = useHoliday()

  const destinationDetails = useDestinationDetailsQuery(
    { destinationId: String(holiday.data.destinationId) },
    { enabled: isNotNull(holiday.data.destinationId) }
  )

  if (holiday.isError || destinationDetails.isError) {
    return <HomeEmpty hero={hero} />
  }

  if (holiday.isSuccess && destinationDetails.isSuccess) {
    return (
      <LayoutHome
        imageUrl={hero.imageUrl}
        header={<HeaderHome />}
        content={destinationDetails.data.content.map(destinationDetailsContent)}
      />
    )
  }

  return <HomeDestinationLoading />
}
